import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AlertModule } from '@component';
import { CoreModule } from '@core';
import { LoginModule } from '@view';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  exports: [BrowserModule, BrowserAnimationsModule, CoreModule],
  imports: [
    AlertModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    LoginModule,
    FormsModule,
    MatFormFieldModule,
    MatNativeDateModule,
    NgOptimizedImage,
    RouterModule,
    MatOption,
    MatSelect,
  ],
})
export class AppModule {}
